import { render, staticRenderFns } from "./BukuBesarPersediaan.vue?vue&type=template&id=700a74fe"
import script from "./BukuBesarPersediaan.vue?vue&type=script&lang=js"
export * from "./BukuBesarPersediaan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports